module.exports = __webpack_public_path__ + "media/images/Interior Window and Door Trim-63d2baf0.webp";